var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let BasicSelectableCard = class BasicSelectableCard extends LitElement {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.variant = 'primary';
        this.size = 'medium';
        this.align = 'left';
    }
    firstUpdated(_changedProperties) {
        this.addEventListener('click', this.handleClick);
    }
    handleClick() {
        this.dispatchEvent(new CustomEvent('card-clicked', {
            detail: { selected: this.selected },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
			<basic-card
				.size=${this.size}
				.align=${this.align}
				style="border-color: ${this.selected ? this._getBorderColor() : '#ddd'}; border-width: 2px; cursor: pointer;"
			>
				<slot></slot>
			</basic-card>
		`;
    }
    _getBorderColor() {
        switch (this.variant) {
            case 'primary': return '#0078d4';
            case 'secondary': return '#888';
            case 'success': return '#28a745';
            case 'danger': return '#dc3545';
            case 'warning': return '#ffc107';
            default: return '#0078d4';
        }
    }
};
BasicSelectableCard.styles = [
    css `
			:host {
				display: block;
				cursor: pointer;
				padding: 0;
			}
			basic-card {
				transition: border-color 0.2s;
				border: 2px solid transparent;
			}
			:host([selected]) basic-card,
			.selected basic-card {
				border-width: 2px;
			}
			:host([selected][variant="primary"]) basic-card {
				border-color: #0078d4;
			}
			:host([selected][variant="secondary"]) basic-card {
				border-color: #888;
			}
			:host([selected][variant="success"]) basic-card {
				border-color: #28a745;
			}
			:host([selected][variant="danger"]) basic-card {
				border-color: #dc3545;
			}
			:host([selected][variant="warning"]) basic-card {
				border-color: #ffc107;
			}
		`
];
__decorate([
    property({ type: Boolean })
], BasicSelectableCard.prototype, "selected", void 0);
__decorate([
    property({ type: String })
], BasicSelectableCard.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], BasicSelectableCard.prototype, "size", void 0);
__decorate([
    property({ type: String })
], BasicSelectableCard.prototype, "align", void 0);
BasicSelectableCard = __decorate([
    customElement('basic-selectable-card')
], BasicSelectableCard);
export { BasicSelectableCard };
//# sourceMappingURL=BasicSelectableCard.js.map